module.exports = __webpack_public_path__ + "images/feature/20150112_leave_requests-036e3510b4d51d9bb220019f2a1a0568.png";